<template>
  <div class="flex flex-1 relative rounded overflow-hidden">
    <div class="absolute w-full h-full z-0">
      <img
        alt="item"
        class="relative w-full h-full left-0 top-0 object-cover"
        src="/src/assets/images/vip_img_1.jpg"
      />
    </div>
    <div class="absolute w-full h-full z-10 vip-gradient"></div>
    <div
      class="flex flex-col z-20 w-full pt-[15px] pl-[12px] pb-[12px] pr-[15px]"
    >
      <div class="flex flex-row flex-1 gap-[8px]">
        <div
          class="flex flex-none justify-center h-[32px] w-[32px] items-center bg-secondary-500 rounded-full"
        >
          <span class="material-symbols-rounded text-xl text-secondary-900"
            >local_shipping</span
          >
        </div>
        <div class="flex flex-col">
          <p class="text-lg font-bold text-secondary-500">
            איסוף + משלוח עד הבית
          </p>
          <p class="text-base font-regular text-white">
            מנהל התחנה יאסוף בשבילכם את ההזמנה ויספק אותה לפתח הבניין.
          </p>
          <div class="flex flex-row items-center mt-[15px] mb-[19px]">
            <p class="flex flex-row text-xs font-regular text-white">
              <span class="font-bold"> כתובת במערכת: </span>
              {{ city }}, {{ street }}
            </p>
            <button
              class="group w-6 h-6 flex justify-center items-center"
              @click="goToStationSetting"
            >
              <span class="material-symbols-rounded text-base text-white"
                >edit</span
              >
            </button>
          </div>
        </div>
      </div>
      <div class="flex flex-row items-center justify-end gap-[12px]">
        <p class="text-base text-white font-bold">20.00₪</p>
        <button-cta
          :disabled="isInCart(product)"
          :small="true"
          @click="handleAddToCart"
        >
          להוסיף להזמנה
        </button-cta>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import axiosInstance from "@/helpers/axios";

export default {
  name: "vip-banner-shipping",
  data() {
    return {
      product: {
        id: 99192349919234,
        name: "איסוף + משלוח עד הבית",
        type: "shipping",
        price: 20,
      },
    };
  },
  methods: {
    ...mapActions({
      addToCart: "cart/addToCart",
      showToast: "orderToast/showToast",
    }),
    handleAddToCart() {
      this.addToCart(this.product);
      this.showToast({});
    },
    goToStationSetting() {
      this.$router.push("/profile");
      setTimeout(() => {
        window.scrollTo({
          top: document.body.scrollHeight,
          behavior: "smooth",
        });
      }, 100);
    },
    ...mapMutations({
      setStreet: "user/setStreet",
      setCity: "user/setCity",
    }),
  },
  computed: {
    ...mapGetters({
      isInCart: "cart/isInCart",
      city: "user/getCity",
      street: "user/getStreet",
    }),
  },
  async mounted() {
    if (!this.street || !this.city) {
      const response = await axiosInstance.get("/profile");
      this.setCity(response.data.city);
      this.setStreet(response.data.street);
    }
  },
};
</script>

<style scoped>
.vip-gradient {
  background: linear-gradient(
    270deg,
    #3f238b 65.63%,
    #3f238b91 100%,
    rgba(26, 6, 79, 0.55) 0%
  );
}
</style>